import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const InputFieldProps = {
  defaultText: PropTypes.string, // Input placeholder text
  name: PropTypes.string.isRequired, // Input name used to identify input
  value: PropTypes.string.isRequired, // Value of the input field
  handleChange: PropTypes.func.isRequired, // Method to invoke when input value changes
  index: PropTypes.number.isRequired, // For identifying the input element
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have successfully returned from API
  handleKeyPress: PropTypes.func.isRequired, // Listens for keyup and keydown events
  handleFocus: PropTypes.func.isRequired, // Lets the app know which field is currently focused
  handleBlur: PropTypes.func.isRequired, // When the input field loses focus
  shortAddress: PropTypes.string, // Short version of address for mobile devices
  editing: PropTypes.bool.isRequired, // If the route is being edited
};

const InputFieldDefaultProps = {
  defaultText: null,
  shortAddress: '',
};

// eslint-disable-next-line arrow-parens
const InputField = props => {
  const {
    defaultText,
    name,
    value,
    handleChange,
    index,
    isMobile,
    directionsLoaded,
    handleKeyPress,
    handleFocus,
    handleBlur,
    shortAddress,
    editing,
  } = props;

  return (
    <input
      id={index}
      type="text"
      name={name}
      value={value}
      data-short-address={shortAddress}
      placeholder={defaultText}
      onChange={e => handleChange(e)}
      className={classNames('form-text tsla-form-text--map', {
        hidden: isMobile && directionsLoaded,
      })}
      onKeyDown={e => handleKeyPress(e)}
      onFocus={e => handleFocus(e)}
      onBlur={e => handleBlur(e)}
      autoComplete="off"
      readOnly={editing ? '' : 'readonly'}
      aria-label="short address"
    />
  );
};

InputField.propTypes = InputFieldProps;

InputField.defaultProps = InputFieldDefaultProps;

export default InputField;
